import {Component, Input, OnChanges, OnDestroy, SimpleChanges} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Subscription} from 'rxjs';
import {startWith} from 'rxjs/operators';

@Component({
  selector: 'ax-domain-edit',
  templateUrl: './domain-edit.component.html',
  styleUrls: ['./domain-edit.component.scss'],
})
export class DomainEditComponent implements OnChanges, OnDestroy {
  @Input() form: FormControl | undefined;
  @Input() label: string;
  @Input() postfix: string;
  @Input() readonly = false;
  @Input() howToLink: string;

  private _regexInvalidChars = /[^a-zA-Z0-9.-]/g;
  private _regexHttps = /^https:\/\//;

  private _subscriptions = new Subscription();

  ngOnChanges(changes: SimpleChanges) {
    if (changes.form && this.form) {
      this._subscriptions.add(
        this.form.valueChanges.pipe(startWith(this.form.value)).subscribe((value) => {
          if (value === '') {
            this.form?.setValue(undefined);
          } else if (this._regexHttps.test(value)) {
            this.form?.setValue(value.replace(this._regexHttps, ''));
          } else if (this._regexInvalidChars.test(value)) {
            this.form?.setValue(value.replace(this._regexInvalidChars, ''));
          }
        })
      );
    }
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  get errors() {
    return this.form?.errors || {};
  }

  errorTranslationKey(errorType: string): string | undefined {
    switch (errorType) {
      case 'domain-in-use':
        return 'page.domain.validation.in-use';
      case 'required':
        return 'property.validation.required';
      default:
        return undefined;
    }
  }
}
